import { render, staticRenderFns } from "./NewSeller.vue?vue&type=template&id=cad4071a&scoped=true"
import script from "./NewSeller.vue?vue&type=script&lang=js"
export * from "./NewSeller.vue?vue&type=script&lang=js"
import style0 from "./NewSeller.vue?vue&type=style&index=0&id=cad4071a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad4071a",
  null
  
)

export default component.exports